import chosen from 'chosen-js';

const $ = window.jQuery;

jQuery( document ).on( 'gform_post_render', function() {

	//
	// Initialize chosen
	//
	$( 'select' ).chosen( {
		disable_search: true,
	} );

	// Hide optgroups with no options (for mobile)
	function checkOptgroups() {
		$( 'select optgroup' ).each(
			function() {
				if ( ! $( this ).find( 'option' ).length ) {
					$( this ).wrap( '<span>' );
				}
			}
		);
	}

	window.requestAnimationFrame( function() {
		window.requestAnimationFrame( checkOptgroups );
	} );

	//
	// Store original select
	//
	const campusSelect = $( '.iec-request-more-information-form select[name="input_5"]' );
	const programSelect = $( '.iec-request-more-information-form select[name="input_6"]' );

	const originalCampus = campusSelect.eq( 0 ).clone();
	const originalProgram = programSelect.eq( 0 ).clone();

	// Trigger select change on load
	window.requestAnimationFrame( function() {
		campusSelect.trigger( 'change' )
	} );

	// Handle campus select change
	campusSelect.change( function() {

		// Store the original program value
		const originalProgramValue = programSelect.val();

		// Rebuild the program select using original
		programSelect.html( originalProgram.html() );

		// Apply the original program value to the cloned program list
		programSelect.val( originalProgramValue );

		// Store the campus value
		const campus = $( this ).val();

		// If the campus has a value (it is NOT the placeholder),
		// loop through and check programs
		if ( campus ) {
			window.IEC_FORM_PROGRAMS.forEach( function( program ) {
				// If the program has this campus attached
				if ( -1 === program.campuses.indexOf( campus ) ) {
					// Remove the program
					$( `.iec-request-more-information-form select[name="input_6"] option[value="${ program.id }"]` ).remove();
				}
			} );
		}

		// Redundant, but makes sure other instances change, too
		campusSelect.val( $( this ).val() )

		// Update the chosen instance
		programSelect.trigger( 'chosen:updated' );

		checkOptgroups();

	} );

	//
	/****************************/
	//

	// Trigger select change on load
	window.requestAnimationFrame( function() {
		programSelect.trigger( 'change' );
	} );

	// Handle campus select change
	programSelect.change( function() {

		// Store the original program value
		const originalCampusValue = campusSelect.val();

		// Rebuild the campus select using original
		campusSelect.html( originalCampus.html() );

		// Apply the original program value to the cloned program list
		campusSelect.val( originalCampusValue );

		// Store the campus value
		const programValue = $( this ).val();

		// If the program has a value (it is NOT the placeholder),
		// And it is not "Undecided",
		// loop through and check campuses
		if ( programValue && 'NS' !== programValue ) {
			window.IEC_FORM_PROGRAMS.forEach( function( program ) {
				// The right program is found
				if ( programValue === program.id ) {
					// Loop through all of the campus options
					campusSelect.find( 'option' ).each( function() {
						// Account for the placeholder
						if ( '' === $( this ).val() ) {
							return;
						}
						// Remove the campus if not in this programs campus list
						if ( -1 === program.campuses.indexOf( $( this ).val().toString() ) ) {
							$( this ).remove();
						}
					} );
				}
			} );
		}

		// Redundant, but makes sure other instances change, too
		programSelect.val( $( this ).val() )

		// Update the chosen instance
		campusSelect.trigger( 'chosen:updated' );

		checkOptgroups();

	} );

} );
